document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('[data-bundle-form]');

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const btn = form.querySelector('[data-bundle-atc]');
      if (!btn || btn.disabled) return;

      const formData = new FormData(form);
      const items = [];

      formData.getAll('items[][id]').forEach((id, index) => {
        items.push({
          id: parseInt(id, 10),
          quantity: parseInt(formData.getAll('items[][quantity]')[index], 10) || 1,
        });
      });

      if (!items.length) return;

      btn.disabled = true;
      const originalText = btn.innerHTML;
      btn.innerHTML = btn.innerHTML.replace(/Add to Cart/, 'Adding...');

      try {
        const cartDrawerEl = document.querySelector('cart-drawer');
        const sectionId = cartDrawerEl?.dataset.sectionId;
        const payload = { items };
        if (sectionId) {
          payload.sections = sectionId;
          payload.sections_url = window.location.pathname;
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error('Cart add failed');
        const data = await response.json();

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, data);
        }
        if (typeof handleFloCartBtn === 'function') {
          handleFloCartBtn();
        }

        btn.innerHTML = btn.innerHTML.replace(/Adding\.\.\./, 'Added!');

        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }, 2000);
      } catch (error) {
        btn.innerHTML = originalText;
        btn.disabled = false;
        console.error('[pdp-better-together] Cart add error:', error);
      }
    });
  });
});
